export const PRIMARY_10 = '#ffe0e9';
export const PRIMARY_100 = '#ea0658';
export const SECONDARY_10 = '#e0e9ff';
export const SECONDARY_100 = '#4e49c7';
